import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../Common/LoaderForSearch";

function SingleHoldingTable(props) {
  let scriptData = props.scriptData;
  let handleScrollScript = props.handleScrollScript;
  let scrollLoader = props.scrollLoader;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        <table className="table last-column">
          <thead>
            <tr>
              <th scope="col" className="text-center">
                Scrip Name
              </th>
              <th scope="col" className="text-center">
                ISIN
              </th>
              <th scope="col" className="text-center">
                {Constants.client_Name}
              </th>
              <th scope="col">{Constants.Client_Code}</th>
              <th scope="col" className="text-center">
                BSE Code
              </th>
              <th scope="col" className="text-center">
                Avg. Cost Price
              </th>
              <th scope="col" className="text-center">
                POA Holding
              </th>
              <th scope="col" className="text-center">
                Magin Pledge
              </th>
              <th scope="col" className="text-center">
                Exchange Pledge
              </th>
              <th scope="col" className="text-center">
                MTF Pledge
              </th>
              <th scope="col" className="text-center">
                MTF Coll Pledge
              </th>
              <th scope="col" className="text-center">
                BFL Pledge
              </th>
              <th scope="col" className="text-center">
                Unpaid
              </th>
              <th scope="col" className="text-center">
                Unsettle
              </th>
              <th scope="col" className="text-center">
                Total Holding
              </th>
              <th scope="col" className="text-center">
                Branch
              </th>
              <th scope="col" className="text-center">
                RM/Dealer Name
              </th>
            </tr>
          </thead>
          <tbody onScroll={(e) => handleScrollScript(e)}>
            {scriptData.map((item, key) => {
              return (
                <tr key={key}>
                  <td>{item?.scriptName || "-"}</td>
                  <td>{item?.isin || "-"}</td>
                  <td>{item?.clientName || "-"}</td>
                  <td>{item?.clientCode || "-"}</td>
                  <td>{item?.bseCode || "-"}</td>
                  <td>{item?.avgPrice || "-"}</td>
                  <td>{item?.poaHold || "-"}</td>
                  <td>{item?.marginPledge || "-"}</td>
                  <td>{item?.exchangePledge || "-"}</td>
                  <td>{item?.mtfPledge || "-"}</td>
                  <td>{item?.mtfCollPledge || "-"}</td>
                  <td>{item?.bflPledge || "-"}</td>
                  <td>{item?.unpaid || "-"}</td>
                  <td>{item?.unsettel || "-"}</td>
                  <td>{item?.totalHolding || "-"}</td>
                  <td>{item?.branchName || "-"}</td>
                  <td>{item?.rmName || "-"}</td>
                </tr>
              );
            })}
          </tbody>
          {scrollLoader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
        </table>
      </div>
    </>
  );
}
export default SingleHoldingTable;
